import * as OrderDAO from "@/dao/order-dao";

export default {
  async getMachines({ commit }) {
    const machines = await OrderDAO.getOrderMachines();
    commit("setMachines", machines);
  },
  async getBasicData({ commit }) {
    const effectiveDate = new Date().toISOString();
    const data = await OrderDAO.getOrderBasicData(effectiveDate);
    commit("setBasicData", data);
  },
  async getList({ commit, getters }, { workListId }) {
    const defaultDeliveryType = getters.deliveryTypes.find(dt => dt.onHoldConfirmationDays);
    const data = await OrderDAO.getOrderList(workListId);
    commit(
      "setOrderList",
      data.map(d => {
        return {
          ...d,
          deliveryTypeId: defaultDeliveryType.id
        };
      })
    );
  },
  async getDeliveryTypes({ commit }) {
    const data = await OrderDAO.getOrderDeliveryTypes();
    commit("setDeliveryTypes", data.reverse());
    commit(
      "setOnHoldDeliveryDetails",
      data.find(d => d.onHoldConfirmationDays)
    );
  },
  onSearchPhraseChange({ commit }, phrase) {
    commit("setSearchPhrase", phrase);
  },
  onOrderDeliveryTypeChange({ commit }, { orderId, deliveryTypeId }) {
    commit("setDeliveryTypeForOrder", { orderId, deliveryTypeId });
  },
  onOrderAmountOfCanistersChange({ commit }, { orderId, amount }) {
    commit("setAmountOfCanisters", { orderId, amount });
  },
  removeOrderFromListById({ state, commit }, orderId) {
    const list = state.orderList.filter(o => o.id !== orderId);
    commit("setOrderList", list);
  },
  async getPriceList({ commit }) {
    const data = await OrderDAO.getOrderPriceList();
    commit("setPriceList", data);
  },
  onFreeContingentChange({ commit, getters }, free) {
    commit("setFreeContingent", free);
    if (free) {
      const defaultDeliveryType = getters.deliveryTypes.find(dt => dt.onHoldConfirmationDays);
      commit(
        "setOrderList",
        getters.orderList.map(d => {
          return {
            ...d,
            deliveryTypeId: defaultDeliveryType.id
          };
        })
      );
    }
  },
  onMachineIdChange({ commit }, machineId) {
    commit("setMachineId", machineId);
  }
};
